/**
 * Locales Homebase's own UI copy is translated into, and therefore the locales
 * offered in the language switcher.
 *
 * A locale belongs here only once a bundle exists for it in
 * `apps/shell/src/app/i18n/locales`, otherwise selecting it shows English.
 * Plugin labels accept a wider list -- see PLUGIN_LABEL_LOCALES.
 */
export const DEFAULT_I18N_LOCALES = ['en', 'fr', 'de', 'es', 'pt-BR'] as const;

export type DefaultI18nLocale = (typeof DEFAULT_I18N_LOCALES)[number];

export const DEFAULT_I18N_FALLBACK_LOCALE: DefaultI18nLocale = 'en';

export const DEFAULT_I18N_STORAGE_KEY = 'broadlume-locale';

/**
 * Each language named in itself, which is what a person looking for their own
 * language in a list scans for.
 */
export const DEFAULT_I18N_LOCALE_NAMES: Record<DefaultI18nLocale, string> = {
  en: 'English',
  fr: 'Français',
  de: 'Deutsch',
  es: 'Español',
  'pt-BR': 'Português (Brasil)',
};
